import { useSelector } from 'react-redux';

// import { UserCareerRoadmap } from '../redux/slice/roadmap-ai/roadmap-ai.type';
import { ThreeYearMilestones } from '../redux/slice/roadmap-ai/roadmap-ai.type';
import { RootState } from '../redux/store';

export const useRoadmapAiContext = () => {
  const allRoadMaps = useSelector((state: RootState) => state.roadmapAi.userData);
  const latestRoadMap = allRoadMaps?.roadMap[allRoadMaps?.roadMap.length - 1];
  return latestRoadMap;
};

export const latestBestFitRecord = () => {
  const bestFitRecord = useRoadmapAiContext()?.best_fit_job;
  return bestFitRecord;
};

export const alternativeCareerPath = () => {
  const alternativePath = useRoadmapAiContext()?.alternate_careers;
  return alternativePath ?? [];
};

export const useThreeYearRoadMapAccordingToSector = (
  sector?: string,
): ThreeYearMilestones | '' | null => {
  const { career_roadmap } = useRoadmapAiContext() || {};
  if (!sector || !career_roadmap) return null;
  return career_roadmap[sector.toLowerCase()] ?? null;
};

export const getSafeThreeYearMilestones = (
  sectorData: '' | ThreeYearMilestones | null,
): ThreeYearMilestones => {
  if (!sectorData || typeof sectorData === 'string') {
    return {
      year_1: {
        career_title: 'N/A',
        base_salary: 0,
        confidence: 0,
        fit_score: 0,
        growth_rate: '',
        required_skills: [],
        sector: '',
      },
      year_2: {
        career_title: 'N/A',
        base_salary: 0,
        confidence: 0,
        fit_score: 0,
        growth_rate: '',
        required_skills: [],
        sector: '',
      },
      year_3: {
        career_title: 'N/A',
        base_salary: 0,
        confidence: 0,
        fit_score: 0,
        growth_rate: '',
        required_skills: [],
        sector: '',
      },
    };
  }
  return sectorData;
};

const integrateSectors = [
  { name: 'Healthcare', shortName: 'healthcare' },
  { name: 'Retail', shortName: 'retail' },
  { name: 'Logistics', shortName: 'logistics' },
  { name: 'Manufacturing', shortName: 'manufacturing' },
  { name: 'IT/Tech-support', shortName: 'it_tech_support' },
  { name: 'Green Tech', shortName: 'green_tech' },
];

export function getShortName(sectorName: string) {
  const sector = integrateSectors.find(
    (item) =>
      sectorName.toLowerCase().includes(item.name.toLowerCase()) ||
      item.name.toLowerCase().includes(sectorName.toLowerCase()),
  );
  return sector ? sector.shortName : sectorName;
}
